import { Component, Host, h, Prop } from '@stencil/core';
import { SVGIcon } from '../icons/svg-icon';

@Component({
  tag: 'opti-custom-dropdown',
  styleUrl: 'opti-custom-dropdown.scss',
  shadow: true,
})
export class OptiCustomDropdown {
  @Prop({ attribute: 'menu-items' }) menuItems: string;
  @Prop() icon: string;

  render() {
    let items = [];
    if (typeof this.menuItems === "string") {
      items = JSON.parse(this.menuItems)
    } else {
      items = this.menuItems
    }

    return (
      <Host>
        <div class="custom-dropdown">
          <button class="custom-dropdown__icon">
            <SVGIcon name={this.icon} />
          </button>
          <dropdown-list class="custom-dropdown__menu" disableFilter items={items}></dropdown-list>
        </div>
      </Host>
    );
  }
}
